import React, { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function AdminDeliveryNotes() {
  const [boys, setBoys] = useState([]);
  const [selectedBoy, setSelectedBoy] = useState("");
  const [note, setNote] = useState("");
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);

  /* LOAD DELIVERY BOYS */
  useEffect(() => {
    axios
      .get("/admin/delivery-boys/")
      .then((res) => {
        setBoys(res.data.delivery_boys || []);
      })
      .catch(() => {
        alert("Failed to load delivery boys");
      });
  }, []);

  /* LOAD NOTES */
  const loadNotes = async (boyId) => {
    if (!boyId) return;

    setLoading(true);
    try {
      const res = await axios.get(
        `/admin/get-cash-notes/?delivery_boy_id=${boyId}`
      );
      setNotes(res.data.notes || []);
    } catch (err) {
      console.error(err);
      alert("Failed to load notes");
    } finally {
      setLoading(false);
    }
  };

  /* SAVE NOTE */
  const saveNote = async () => {
    if (!selectedBoy || !note.trim()) {
      alert("Select delivery boy & write note");
      return;
    }

    try {
      await axios.post("/admin/save-cash-note/", {
        delivery_boy_id: selectedBoy,
        note: note.trim(),
      });

      setNote("");
      loadNotes(selectedBoy);
      alert("Note saved");
    } catch (err) {
      console.error(err);
      alert("Failed to save note");
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h2>📝 Delivery Boy Notes</h2>

      <select
        value={selectedBoy}
        onChange={(e) => {
          setSelectedBoy(e.target.value);
          loadNotes(e.target.value);
        }}
        style={{ width: 320, padding: 8, marginBottom: 16 }}
      >
        <option value="">Select Delivery Boy</option>
        {boys.map((b) => (
          <option key={b.id} value={b.id}>
            {b.name} ({b.phone})
          </option>
        ))}
      </select>

      <textarea
        placeholder="Write note here..."
        value={note}
        onChange={(e) => setNote(e.target.value)}
        style={{ width: "100%", padding: 10, minHeight: 90 }}
      />

      <button
        onClick={saveNote}
        style={{
          marginTop: 10,
          padding: "8px 16px",
          background: "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: 4,
        }}
      >
        Save Note
      </button>

      <div
  style={{
    marginTop: 30,
    maxHeight: 400,          // 👈 allows many notes
    overflowY: "auto",       // 👈 scroll
    border: "1px solid #e5e7eb",
    padding: 12,
    borderRadius: 6,
  }}
>
        <h3>Notes History</h3>

        {loading && <p>Loading...</p>}
        {!loading && notes.length === 0 && <p>No notes found</p>}

        {notes.map((n, i) => (
          <div
            key={i}
            style={{
              padding: 12,
              border: "1px solid #e5e7eb",
              borderRadius: 6,
              marginBottom: 8,
              background: "#fafafa",
            }}
          >
            <div style={{ fontSize: 12, color: "#6b7280" }}>
              {n.date}
            </div>
            <div>{n.note}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
